import React from "react"

export const StoreListSkeleton = () => {
  return (
    <div className="mt-4 flex w-[90%]  max-w-screen-lg animate-pulse flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white p-4 shadow-sm md:w-full md:flex-row">
      <div className="h-36 w-full rounded-xl bg-gray-200 md:h-[420px] md:w-1/3" />
      <div className="flex w-full flex-col justify-between p-4 md:w-2/3">
        <div className="space-y-3">
          <div className="h-6 w-2/3 rounded bg-gray-200" />
          <div className="h-4 w-1/4 rounded bg-gray-200" />
          <div className="h-4 w-1/3 rounded bg-gray-200" />
          <div className="mt-4 flex flex-col space-y-2 md:flex-row md:space-x-4 md:space-y-0">
            <div className="h-4 w-48 rounded bg-gray-200" />
            <div className="h-4 w-56 rounded bg-gray-200" />
            <div className="h-4 w-64 rounded bg-gray-200" />
          </div>
        </div>
        <div className="mt-6 space-y-3 border-t border-gray-100 pt-4">
          <div className="h-6 w-16 rounded bg-gray-200" />
          <div className="h-4 w-2/3 rounded bg-gray-200" />
          <div className="h-4 w-1/3 rounded bg-gray-200" />
        </div>
      </div>
    </div>
  )
}
